export const fecha = (fechas) => {
    const fh = new Date(fechas);
    const dia = fh.getDate();
    const mes = fh.getMonth();
    const anual = fh.getFullYear();
    return `${dia}/${mes}/${anual}`
}